import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Tab {
  id: string;
  title: string;
  component: string;
}

@Injectable({
  providedIn: 'root',
})
export class SeekerTabsService {
  private activeTabSubject = new BehaviorSubject<string>('previews');
  public activeTab$ = this.activeTabSubject.asObservable();

  private tabs: Tab[] = [
    // { id: 'advanced-search', title: 'seekerDashboard.tabs.advancedSearch', component: 'AdvancedSearchComponent' },
    // { id: 'favorites', title: 'seekerDashboard.tabs.favorites', component: 'FavoritesComponent' },
    { id: 'previews', title: 'seekerDashboard.tabs.previews', component: 'PreviewsComponent' },
    { id: 'bookings', title: 'seekerDashboard.tabs.bookings', component: 'BookingsComponent' },
    { id: 'my-properties', title: 'seekerDashboard.tabs.myProperties', component: 'MyProperties' },
    { id: 'my-contracts', title: 'seekerDashboard.tabs.myContracts', component: 'MyContracts' },
    { id: 'my-installments', title: 'seekerDashboard.tabs.myInstallments', component: 'MyInstallmentsComponent' },
    { id: 'my-tickets', title: 'ticket.myTickets', component: 'SeekerTicketsComponent' },
    {
      id: 'comparison',
      title: 'seekerDashboard.tabs.comparison',
      component: 'ComparisonComponent',
    },
    // { id: 'alerts', title: 'seekerDashboard.tabs.alerts', component: 'AlertsComponent' },
    { id: 'profile', title: 'seekerDashboard.tabs.profile', component: 'SeekerProfileComponent' },
  ];

  constructor() {}

  getTabs(): Tab[] {
    return this.tabs;
  }

  getActiveTab(): string {
    return this.activeTabSubject.value;
  }

  setActiveTab(tabId: string): void {
    this.activeTabSubject.next(tabId);
  }

  getTabById(tabId: string): Tab | undefined {
    return this.tabs.find((tab) => tab.id === tabId);
  }
}
